import { useMemo } from "react";
import type { ColumnCatalog, ColumnOption } from "@/components/application/table/column-layout";

const GROUPS = ["Sales", "Reach", "Engagement", "Identity", "Products", "Activity", "Safety"];

const BASE_OPTIONS: ColumnOption[] = [
  { id: "gmv", group: "Sales" },
  { id: "unitSales", group: "Sales" },
  { id: "gmvTrend", group: "Sales" },
  { id: "gpm", group: "Sales" },
  { id: "conversion", group: "Sales" },
  { id: "gmvPerView", group: "Sales" },
  { id: "views", group: "Reach" },
  { id: "viewsTrend", group: "Reach" },
  { id: "publishDate", group: "Identity" },
  { id: "creator", group: "Identity" },
  { id: "creatorFollowers", group: "Identity" },
  { id: "daysSincePublished", group: "Identity" },
  { id: "productsPromoted", group: "Products" },
  { id: "lastContacted", group: "Activity" },
];

const AD_OPTIONS: ColumnOption[] = [{ id: "adFlag", group: "Activity" }];

const SAFETY_OPTIONS: ColumnOption[] = [
  { id: "status", group: "Safety" },
  { id: "risks", group: "Safety" },
];

const DEFAULTS = ["gmv", "unitSales", "views", "status", "lastContacted", "publishDate"];

export const useVideoColumnCatalog = ({
  isAssurance,
  adsConnected,
}: {
  isAssurance: boolean;
  adsConnected: boolean;
}): ColumnCatalog =>
  useMemo(() => {
    const options = [...BASE_OPTIONS, ...(adsConnected ? AD_OPTIONS : []), ...(isAssurance ? SAFETY_OPTIONS : [])];
    const ids = new Set(options.map((option) => option.id));
    return {
      tableKey: "videos",
      options,
      defaults: DEFAULTS.filter((id) => ids.has(id)),
      groups: GROUPS,
    };
  }, [isAssurance, adsConnected]);
